export const formatPrice = (price: number) =>
    `$ ${new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 0,
    })
        .format(price)
        .replace(/,/g, ' ')}`;
